import React from 'react'
import { useDispatch } from 'react-redux';
import PrimaryTheme from '../Themes/Primary';

export default function RecAndDecBtn(props: any) {
    const dispatch = useDispatch()
    const handleRecommendModal = (recStatus: any, items: any) => {

        dispatch({
            type: 'ALERT_MODAL',
            payload: true
        });
        dispatch({
            type: "REC_STATUS", payload: { recStatus, ...items }
        })
    }
    return (props.itemRecord.awaitingAcknowledgement === false ? <div style={{ display: "flex",justifyContent:"center" }}>

        <button style={{ background: "rgba(39, 132, 86, 0.6)", paddingTop: "10px", paddingBottom: "10px", paddingLeft: "24px", paddingRight: "24px", borderTopLeftRadius: "100px", borderBottomLeftRadius: "100px", border: "none", color: "white" }} disabled >Recommended</button> <button style={{ background: props.itemRecord.applicationStatusName === "Declined" ? PrimaryTheme.danger : PrimaryTheme.warn, paddingTop: "10px", paddingBottom: "10px", paddingLeft: "24px", paddingRight: "24px", borderTopRightRadius: "100px", borderBottomRightRadius: "100px", border: "none", color: "white", }} disabled>Declined</button>
    </div> : <div>

        <button onClick={() => handleRecommendModal("Recommend", props.itemRecord)} style={{ background: PrimaryTheme.success, paddingTop: "10px", paddingBottom: "10px", paddingLeft: "24px", paddingRight: "24px", borderTopLeftRadius: "100px", borderBottomLeftRadius: "100px", border: "none", color: "white" }}>Recommend</button> <button onClick={() => handleRecommendModal("Declined", props.itemRecord)} style={{ background: PrimaryTheme.danger, paddingTop: "10px", paddingBottom: "10px", paddingLeft: "24px", paddingRight: "24px", borderTopRightRadius: "100px", borderBottomRightRadius: "100px", border: "none", color: "white", }}>Decline</button>
    </div>

    )
}
